import axios from 'axios';
import { GET_LINE_OPTIC_ID_API_URL, GET_WELL_ID_API_URL, GET_PILLAR_ID_API_URL,
  GET_PON_BOX_ID_API_URL, GET_COUPLING_ID_API_URL, GET_FOB_ID_API_URL,
  GET_EQUIPMENT_CANTON_API_URL, GET_WELL_CANTON_API_URL, GET_PILLAR_CANTON_API_URL,
  GET_COUPLING_CANTON_API_URL, GET_FOB_CANTON_API_URL, GET_LINE_OPTIC_CANTON_API_URL, GET_PON_BOX_CANTON_API_URL,
  GET_FOB_COORD_API_URL,
  GET_COUPLING_COORD_API_URL,
  GET_PON_BOX_COORD_API_URL,
  GET_PILLAR_COORD_API_URL,
  GET_WELL_COORD_API_URL,
  GET_LINE_OPTIC_COORD_API_URL} from '../OpticApiConfig';
import { radiusWell, radiusPillar } from '../Constants/ConstantsOptics';  

// отображение оптики для карты (параметры опты)
const processLineOpticData = (lineOpticData) => {
    const cableData = lineOpticData.reduce((acc, coordinate) => {
      if (!acc[coordinate.highwayLineId]) {
        acc[coordinate.highwayLineId] = {
          coordinates: [],
          color: coordinate.cableColor,
          type: coordinate.cableTypeKind,
          width: coordinate.cableWidth,
          fiberQuantity: coordinate.cableFiberQuantity,
          activity: coordinate.activity
     };
      }
      acc[coordinate.highwayLineId].coordinates.push([coordinate.latitude, coordinate.longitude]);
      return acc;
    }, {});
    return cableData;
  };



   // формируем Territory для кабеля
  function generateTerritoryByHighwayLineId(data) {
    const territoryByHighwayLineId = {};
  
    // Группируем данные по highwayLineId, canton и region
    const groupedByCanton = data.reduce((acc, item) => {
      const { highwayLineId, canton, region, area } = item;
  
      // Исключаем элементы, где canton, region или area равны нулю
      if (canton && region && area) {
        if (!acc[highwayLineId]) acc[highwayLineId] = {};
        if (!acc[highwayLineId][canton]) acc[highwayLineId][canton] = {};
        if (!acc[highwayLineId][canton][region]) acc[highwayLineId][canton][region] = new Set();
  
        acc[highwayLineId][canton][region].add(area);
      }
  
      return acc;
    }, {});
  
    // Формируем массив territory для каждого highwayLineId
    for (const highwayLineId in groupedByCanton) {
      const cantons = groupedByCanton[highwayLineId];
      const territory = [];
  
      for (const canton in cantons) {
        const regions = cantons[canton];
        const regionArray = [];
  
        for (const region in regions) {
          regionArray.push({
            region,
            areas: Array.from(regions[region]), 
          });
        }
  
        territory.push({
          canton,
          regions: regionArray,
        });
      }
  
      territoryByHighwayLineId[highwayLineId] = territory;
    }
  
    return territoryByHighwayLineId;
  }

// Получение кабеля по ID
export const GetComponentCable = async (id, setCableData, setDescriptionOptic, setContext) => {  

      try {
        if (id === "null") {
          return;
        }
        const token = localStorage.getItem('token');
           
        let apiUrlLineOpticHighway = `${GET_LINE_OPTIC_ID_API_URL}?id=${id}`;

        try {
          const resultLineOpticHighway = await axios.get(apiUrlLineOpticHighway, {
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          });
          const uniqueData = resultLineOpticHighway.data.filter((item, index, self) =>
          index === self.findIndex((t) => t.id === item.id)
        );

          const territoryByHighwayLineId = generateTerritoryByHighwayLineId(resultLineOpticHighway.data);
    
        const updatedUniqueData = uniqueData.map(item => ({
          ...item,
          territory: territoryByHighwayLineId[item.highwayLineId] || [],
        }));


       
        const processedData = processLineOpticData(resultLineOpticHighway.data); 
        setCableData(processedData);
        setDescriptionOptic(updatedUniqueData);
        setContext( updatedUniqueData);


        } catch (error) {
         // showSnackbar('Ошибка!','snackbarOk');
        }
      } catch (error) {
        //showSnackbar('Ошибка!','snackbarOk');
      }

    }

    // Получение кабеля по координатам
   export const GetComponentCableByCoords = async (
  lat,
  lng,
  setCableData,
  setDescriptionOptic,
  setContext
) => {
  try {
    if (!lat || !lng) return;

    const token = localStorage.getItem("token");

    const apiUrl = `${GET_LINE_OPTIC_COORD_API_URL}?lat=${lat}&lng=${lng}`;

    const result = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = result.data;

    if (!data || data.length === 0) return;

    // unique
    const uniqueData = data.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.id === item.id)
    );

    const territoryByHighwayLineId =
      generateTerritoryByHighwayLineId(data);

    const updatedUniqueData = uniqueData.map((item) => ({
      ...item,
      territory: territoryByHighwayLineId[item.highwayLineId] || [],
    }));

    // 🔥 ГЛАВНОЕ — НЕ ТРОГАЕМ processedData
    const processedData = processLineOpticData(data);

    // ❗ ВАЖНО: как в ID методе
    setCableData(processedData);
    setDescriptionOptic(updatedUniqueData);
    setContext(updatedUniqueData);

  } catch (error) {
    console.error("GetComponentCableByCoords error:", error);
  }
};
    // Получение well по ID
export const GetComponentWell = async (id, setWellData) => {  

  try {
    if (id === "null") {
      return;
    }
    const token = localStorage.getItem('token');
       
    let apiUrlWell = `${GET_WELL_ID_API_URL}?id=${id}`;

    try {
      const resultWell = await axios.get(apiUrlWell, {
          headers:{
             'Authorization': `Bearer ${token}` 
          }
          });
          setWellData(resultWell.data);
    } catch (error) {
     // showSnackbar('Ошибка!','snackbarOk');
    }
  } catch (error) {
    //showSnackbar('Ошибка!','snackbarOk');
  }

}

 // Получение well по координатам
export const GetComponentWellByCoords = async (lat, lng, setWellData) => {  

  try {
    if (!lat || !lng) {
      return;
    }
    const token = localStorage.getItem('token');
       
    let apiUrlWell = `${GET_WELL_COORD_API_URL}?lat=${lat}&lng=${lng}`;

    try {
      const resultWell = await axios.get(apiUrlWell, {
          headers:{
             'Authorization': `Bearer ${token}` 
          }
          });
          setWellData(resultWell.data);
    } catch (error) {
     // showSnackbar('Ошибка!','snackbarOk');
    }
  } catch (error) {
    //showSnackbar('Ошибка!','snackbarOk');
  }

}

// Получение pillar по ID
export const GetComponentPillar = async (id, setPillarData) => {  

  try {
    if (id === "null") {
      return;
    }
    const token = localStorage.getItem('token');
       
    let apiUrlPillar = `${GET_PILLAR_ID_API_URL}?id=${id}`;

    try {
      const resultPillar = await axios.get(apiUrlPillar, {
          headers:{
             'Authorization': `Bearer ${token}` 
          }
          });
          setPillarData(resultPillar.data);
    } catch (error) {
     // showSnackbar('Ошибка!','snackbarOk');
    }
  } catch (error) {
    //showSnackbar('Ошибка!','snackbarOk');
  }

}

// Получение pillar по координатам
export const GetComponentPillarByCoords = async (lat, lng, setPillarData) => {  

  try {
    if (!lat || !lng) {
      return;
    }

    const token = localStorage.getItem('token');
       
    let apiUrlPillar = `${GET_PILLAR_COORD_API_URL}?lat=${lat}&lng=${lng}`;

    try {
      const resultPillar = await axios.get(apiUrlPillar, {
          headers:{
             'Authorization': `Bearer ${token}` 
          }
          });
          setPillarData(resultPillar.data);
    } catch (error) {
     // showSnackbar('Ошибка!','snackbarOk');
    }
  } catch (error) {
    //showSnackbar('Ошибка!','snackbarOk');
  }

}

// Получение pon-box по ID
export const GetComponentPonBox = async (id, setPonBoxData) => {  

  try {
    if (id === "null") {
      return;
    }
    const token = localStorage.getItem('token');
       
    let apiUrlPonBox = `${GET_PON_BOX_ID_API_URL}?id=${id}`;

    try {
      const resultPonBox = await axios.get(apiUrlPonBox, {
          headers:{
             'Authorization': `Bearer ${token}` 
          }
          });
          setPonBoxData(resultPonBox.data);
    } catch (error) {
     // showSnackbar('Ошибка!','snackbarOk');
    }
  } catch (error) {
    //showSnackbar('Ошибка!','snackbarOk');
  }

}

// Получение pon-box по координатам
export const GetComponentPonBoxByCoords = async (lat, lng, setPonBoxData) => {  

  try {
    if (!lat || !lng) {
      return;
    }
    const token = localStorage.getItem('token');
       
    let apiUrlPonBox = `${GET_PON_BOX_COORD_API_URL}?lat=${lat}&lng=${lng}`;

    try {
      const resultPonBox = await axios.get(apiUrlPonBox, {
          headers:{
             'Authorization': `Bearer ${token}` 
          }
          });
          setPonBoxData(resultPonBox.data);
    } catch (error) {
     // showSnackbar('Ошибка!','snackbarOk');
    }
  } catch (error) {
    //showSnackbar('Ошибка!','snackbarOk');
  }

}

// Получение coupling по ID
export const GetComponentCoupling = async (id, setCouplingData) => {  

  try {
    if (id === "null") {
      return;
    }
    const token = localStorage.getItem('token');
       
    let apiUrlCoupling= `${GET_COUPLING_ID_API_URL}?id=${id}`;

    try {
      const resultCoupling = await axios.get(apiUrlCoupling, {
          headers:{
             'Authorization': `Bearer ${token}` 
          }
          });
          setCouplingData(resultCoupling.data);
    } catch (error) {
     // showSnackbar('Ошибка!','snackbarOk');
    }
  } catch (error) {
    //showSnackbar('Ошибка!','snackbarOk');
  }

}

// Получение coupling по координатам
export const GetComponentCouplingByCoords = async (lat, lng, setCouplingData) => {  

  try {
     if (!lat || !lng) {
      return;
    }
    const token = localStorage.getItem('token');
       
    let apiUrlCoupling= `${GET_COUPLING_COORD_API_URL}?lat=${lat}&lng=${lng}`;

    try {
      const resultCoupling = await axios.get(apiUrlCoupling, {
          headers:{
             'Authorization': `Bearer ${token}` 
          }
          });
          setCouplingData(resultCoupling.data);
    } catch (error) {
     // showSnackbar('Ошибка!','snackbarOk');
    }
  } catch (error) {
    //showSnackbar('Ошибка!','snackbarOk');
  }

}

// Получение Fob по ID
export const GetComponentFob = async (id, setFobData) => {  

  try {
    if (id === "null") {
      return;
    }
    const token = localStorage.getItem('token');
       
    let apiUrlFob= `${GET_FOB_ID_API_URL}?id=${id}`;

    try {
      const resultFob = await axios.get(apiUrlFob, {
          headers:{
             'Authorization': `Bearer ${token}` 
          }
          });
          setFobData(resultFob.data);
    } catch (error) {
     // showSnackbar('Ошибка!','snackbarOk');
    }
  } catch (error) {
    //showSnackbar('Ошибка!','snackbarOk');
  }

}

// Получение Fob по координатам
export const GetComponentFobByCoords = async (lat, lng, setFobData) => {  

  try {
    if (!lat || !lng) {
      return;
    }

    const token = localStorage.getItem('token');
       
    let apiUrlFob = `${GET_FOB_COORD_API_URL}?lat=${lat}&lng=${lng}`;

    try {
      const resultFob = await axios.get(apiUrlFob, {
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });

      setFobData(resultFob.data);

    } catch (error) {
      console.error('Ошибка запроса FOB по координатам', error);
    }

  } catch (error) {
    console.error('Общая ошибка', error);
  }
};
// // отображение территории из фильтра (Округ / Регион / Ветка)
// export const GetCantonFilter = async ( selectedRegionRef, selectedAreaRef, selectedCanton, 
//             setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,
//             setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setPosition,setStatusModalTerritory,setDescriptionOptic, setPonBoxLocationData) => {  

//       const selectedRegion = selectedRegionRef.current.value;
    
//       const selectedArea = selectedAreaRef.current.value;
//       setSwitchesData([]);
//       setWellData([]);
//       setPillarData([]);
//       setPonBoxLocationData([]);
//       setCouplingLocationData([]);
//       setFobLocationData([]);
//       setGroupedCoordinatesWithColorTypeAndWidth([]);
//       setLoadingCunton(true);
      
//       try {
//         if (selectedCanton === "null") {
//          // console.error("Выберите округ!");
//           return;
//         }
//         const token = localStorage.getItem('token');

//         let apiUrlEquipment = `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;
         
//         const resultEquipment = await axios.get(apiUrlEquipment, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });   

//         const { latitude, longitude } = resultEquipment.data[0];
//         setPosition([latitude, longitude]);
//         setSwitchesData(resultEquipment.data);
//         setStatusModalTerritory('canton');

//          let apiUrlWell = `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat=${latitude}&centerLon=${longitude}`;
      
//          let apiUrlPillar = `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat=${latitude}&centerLon=${longitude}`;

//          let apiUrlCouplingLocation = `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//          let apiUrlFobLocation = `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//          let apiUrlPonBoxLocation = `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//          let apiUrlLineOptic = `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegion}&area=${selectedArea}`;

//         const resultWell = await axios.get(apiUrlWell, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setWellData(resultWell.data);

//         const resultPillar  = await axios.get(apiUrlPillar, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPillarData(resultPillar.data);

//         const resultCouplingLocation  = await axios.get(apiUrlCouplingLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setCouplingLocationData(resultCouplingLocation.data);

//         const resultFobLocation  = await axios.get(apiUrlFobLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setFobLocationData(resultFobLocation.data);

//         const resultPonBoxLocation  = await axios.get(apiUrlPonBoxLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPonBoxLocationData(resultPonBoxLocation.data);

//         try {
//           const resultLineOptic = await axios.get(apiUrlLineOptic, {
//             headers:{
//               'Authorization': `Bearer ${token}` 
//             }
//           });
//           const uniqueData = resultLineOptic.data.filter((item, index, self) =>
//             index === self.findIndex((t) => t.id === item.id)
//           );

//           const processedData = processLineOpticData(resultLineOptic.data); 
//           setGroupedCoordinatesWithColorTypeAndWidth(processedData);

//           setDescriptionOptic(uniqueData);
//         } catch (error) {
//           //console.error("Error fetching LineOptic data:", error);
//         }
//       } catch (error) {
//        // console.error("Error fetching data:", error);
//       } finally {
//         setLoadingCunton(false);
//       }
//     }

//     // отображение территории из фильтра (Округ / Регион / Ветка)  второй метод для перерисовки во внесении DrawerCanton
// export const GetCantonFilterRefresh = async ( selectedRegoin, selectedArea, selectedCanton,
//             setSwitchesData, setWellData, setPillarData, setCouplingLocationData, setFobLocationData,
//             setGroupedCoordinatesWithColorTypeAndWidth, setLoadingCunton, setPosition,setStatusModalTerritory,setDescriptionOptic, setPonBoxLocationData) => {  

//       setSwitchesData([]);
//       setWellData([]);
//       setPillarData([]);
//       setCouplingLocationData([]);
//       setFobLocationData([]);
//       setGroupedCoordinatesWithColorTypeAndWidth([]);
//       setLoadingCunton(true);
      
//       try {
       
//         if (selectedCanton === "null") {
//          // console.error("Выберите округ!");
//           return;
//         }
//         const token = localStorage.getItem('token');

//         let apiUrlEquipment = `${GET_EQUIPMENT_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         const resultEquipment = await axios.get(apiUrlEquipment, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });   
//         const { latitude, longitude } = resultEquipment.data[0];
//         setPosition([latitude, longitude]);
//         setSwitchesData(resultEquipment.data);
//         setStatusModalTerritory('canton');
        
//         let apiUrlWell = `${GET_WELL_CANTON_API_URL}?radius=${radiusWell}&centerLat=${latitude}&centerLon=${longitude}`;
      
//         let apiUrlPillar = `${GET_PILLAR_CANTON_API_URL}?radius=${radiusPillar}&centerLat=${latitude}&centerLon=${longitude}`;

//         let apiUrlCouplingLocation = `${GET_COUPLING_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         let apiUrlFobLocation = `${GET_FOB_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         let apiUrlLineOptic = `${GET_LINE_OPTIC_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         let apiUrlPonBoxLocation = `${GET_PON_BOX_CANTON_API_URL}?canton=${selectedCanton}&region=${selectedRegoin}&area=${selectedArea}`;

//         const resultWell = await axios.get(apiUrlWell, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setWellData(resultWell.data);

//         const resultPillar  = await axios.get(apiUrlPillar, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPillarData(resultPillar.data);

//         const resultCouplingLocation  = await axios.get(apiUrlCouplingLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setCouplingLocationData(resultCouplingLocation.data);

//         const resultFobLocation  = await axios.get(apiUrlFobLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setFobLocationData(resultFobLocation.data);

//         const resultPonBoxLocation  = await axios.get(apiUrlPonBoxLocation, {
//           headers:{
//             'Authorization': `Bearer ${token}` 
//           }
//         });
//         setPonBoxLocationData(resultPonBoxLocation.data);

//         try {
//           const resultLineOptic = await axios.get(apiUrlLineOptic, {
//             headers:{
//               'Authorization': `Bearer ${token}` 
//             }
//           });

//           const uniqueData = resultLineOptic.data.filter((item, index, self) =>
//             index === self.findIndex((t) => t.id === item.id)
//           );

//           const processedData = processLineOpticData(resultLineOptic.data); 
//           setGroupedCoordinatesWithColorTypeAndWidth(processedData);
//           setDescriptionOptic(uniqueData);

          
//         } catch (error) {
//           //console.error("Error fetching LineOptic data:", error);
//         }
//       } catch (error) {
//        // console.error("Error fetching data:", error);
//       } finally {
//         setLoadingCunton(false);
//       }
//     }